import { render } from "./AppointmentsTable.vue?vue&type=template&id=ba7ebcd8"
import script from "./AppointmentsTable.vue?vue&type=script&lang=js"
export * from "./AppointmentsTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__